import { Component, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, PosterViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { PosterService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-conference-poster-listing',
  templateUrl: 'conference-poster-listing.component.html',
})
export class ConferencePosterListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  posters: PosterViewModel[];

  constructor(private posterService: PosterService, public auth: AuthenticationService,) {}

  ngOnInit(): void {
    this.posterService.getPostersForConference(this.conference.id).subscribe((result) => {
      this.posters = result.filter(x=>x.approved);
      this.initialized = true;
    });
  }
}
